import * as React from "react";
import classnames from "classnames";
/* empty css                          */
const SuggestionTopContent = ({
  className,
  cursor,
  suggestionTopContent,
  onClick,
  setHovered,
  setFocus,
  ...rest
}) => {
  const onMouseEnter = React.useCallback(() => setHovered("content"), [setHovered]);
  const onMouseLeave = React.useCallback(() => setHovered(void 0), [setHovered]);
  const onFocus = React.useCallback(() => {
    setFocus(0);
  }, [setFocus]);
  const onBlur = React.useCallback(() => {
    setFocus(-1);
  }, [setFocus]);
  const onClickHandler = React.useCallback(
    (e) => {
      if (e.currentTarget === document.activeElement && onClick) {
        e.preventDefault();
        onClick(e);
      }
    },
    [onClick]
  );
  return /* @__PURE__ */ React.createElement(
    "li",
    {
      ...rest,
      role: "presentation",
      className: classnames(
        "suggestion-top-content",
        {
          "suggestion-top-content--active": cursor === 0
        },
        className
      )
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        id: "autocomplete-suggestion-item-0",
        role: "option",
        "aria-selected": cursor === 0,
        onMouseEnter,
        onMouseLeave,
        onFocus,
        onBlur,
        onClick: onClickHandler,
        className: "suggestion-top-content__button"
      },
      suggestionTopContent
    )
  );
};
export {
  SuggestionTopContent as default
};
//# sourceMappingURL=SuggestionTopContent.js.map
